import script from "./CategoryCardDataType.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCardDataType.vue?vue&type=script&setup=true&lang=js"

import "./CategoryCardDataType.vue?vue&type=style&index=0&id=62168189&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62168189"]])

export default __exports__